import React, { useContext } from 'react'
import { Col, Row } from 'reactstrap'
import { SchoolContext } from '../context/SchoolContext'
import LeftNavigation from '../commons/LeftNav';
import LeftNavigationMobile from '../commons/LeftNavMobile';
import Spinner from '../commons/Spinner';
import NavMenu from '../commons/NavMenu';
import NavMenuMobile from '../commons/NavMenuMobile';
import { useHistory } from 'react-router-dom';

const DashboardLayout = (props) => {
  const { children } = props
  const { loading } = useContext(SchoolContext);
  // const checkSchool = localStorage.getItem("curr_school");
  const history = useHistory();
  const pathname = history["location"].pathname
  const school_id = Number(pathname.split('/').pop());

  const nav = () => {
    if (school_id === 0 || pathname === `/home/${school_id}`) {
      return ('')
    }
    if (pathname === '/home' || pathname === '/home/user' || pathname === '/home/notice' || school_id > 0) {
      return (<div className="navigation-bar">
        <LeftNavigation setControlType={props.setControlType} />
        <LeftNavigationMobile setControlType={props.setControlType} />
      </div >)
    }
  }

  if (loading) return <Spinner />
  return (
    <div className={!Number.isNaN(school_id) && school_id > 0 ? "innerPageNav" : "outerPageNav"}>
      <NavMenu {...props} />
      <NavMenuMobile {...props} />
      <Row className="main-section">
        {nav()}
        {/* <div className="navigation-bar">
          <LeftNavigation />
          <LeftNavigationMobile />
        </div > */}
        <Col style={{ padding: "0" }} className="contentSection">
          {children}
        </Col>
      </Row>
    </div>
  )
}

DashboardLayout.propTypes = {}

export default DashboardLayout